import React, { createContext, useContext, useState } from "react";
import { initialForm } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import { validatePaymentMode } from "../../../../unAssigned/collectPayment/selectPaymentMode/components/constant";

export const ReceiptListContext = createContext({
  //   currentPageState: "SEARCH_RECEIPT",
  //   setCurrentPageState: () => {},
  globalFilter: {},
  setGlobalFilter: () => {},
});

export const FILTER_MENU = {
  businessAreaList: [],
  courseTypeList: [],
  receiptTypeList: [],
  termList: [],
  courseIdList: [],
  startDate: "",
  endDate: "",
};

export const FILTER__FORM_FIELDS_GLOBAL = {
  searchField: "psid",
  psid: "",
  applicationId: "",
  ...FILTER_MENU,
};

export const usePaymentCollectionReceiptContext = () => {
  return useContext(ReceiptListContext);
};

export const ReceiptListProvider = ({ children, ...props }) => {
  // global search
  const [globalFilter, setGlobalFilter] = useState({
    ...FILTER__FORM_FIELDS_GLOBAL,
  });

  const [buDescriptionMap, setBuDescriptionMap] = useState({});

  const [dropdownOptions, setDropdownOptions] = useState({
    courseTypeList: [],
    receiptTypeList: [],
    termList: [],
  });
  const [filterCount, setFilterCount] = useState(0);

  const [currentStep, setCurrentStep] = useState(0);
  const [currentPaymentMode, setCurrentPaymentMode] = useState("default");
  const [bankDropdown, setBankDropdown] = useState([]);
  const [paymentModeForm, setPaymentModeForm] = useState(initialForm);
  const [studentBasicDetails, setStudentBasicDetails] = useState({});
  const [applicationId, setApplicationId] = useState("");
  const [selectedFilter, setFilterHandler] = useState("all");
  const [studentChargesList, setStudentCharges] = useState({
    REGULAR_CHARGES: "",
    OTHER_CHARGES: "",
  });
  const [studentChargesListFiltered, setStudentChargesListFiltered] = useState(
    []
  );
  const [selectedIndexMapCharges, setSelectedIndexMapCharges] = useState({
    REGULAR_CHARGES: {},
    OTHER_CHARGES: {},
  });
  const [selectedChargesAmount, setSelectedChargesAmount] = useState(0);
  const [partialAddAmount, setPartialPaymentAmount] = useState(0);
  const [selectedCharges, setSelectedCharges] = useState({
    REGULAR_CHARGES : [],
    OTHER_CHARGES : []
  });
  const [disableItemSelection, setDisableItemSelection] = useState({
    isAutoSelect: false,
  });
  const [roleId, setRoleId] = useState([]);
  const [bankMasterId, setBankMasterId] = useState({});
  const [balanceAmount, setBalanceAmount] = useState();
  const [balanceMode, setBalanceMode] = useState(false);
  const [loader, setloader] = useState(false);
  const [collectPayment, setCollectPayment] = useState([]);
  const [collectVoucherList, setCollectVoucherList] = useState([]);
  const [paymentModeIdLimitList, setPaymentModeIdLimitList] = useState({
    paymentModeIdList: [],
    maxLimit: "",
  });
  const paymentModeFormHandler = (key, value) => {
    setPaymentModeForm({ ...paymentModeForm, [key]: value });
  };
  const [modifyPaymentModeData, setModifyPaymentModeData] = useState({});
  const [noAmountChange, setNoAmountChange] = useState(false);
  const [totalUnpaidAmount, setTotalUnpaidAmount] = useState(0);
  const [state,setState]= useState('')

  return (
    <ReceiptListContext.Provider
      value={{
        globalFilter,
        setGlobalFilter,

        buDescriptionMap,
        setBuDescriptionMap,

        dropdownOptions,
        setDropdownOptions,

        filterCount,
        setFilterCount,

        setApplicationId,
        studentBasicDetails,
        setStudentBasicDetails,
        selectedFilter,
        setFilterHandler,
        studentChargesList,
        studentChargesListFiltered,
        setStudentCharges,
        selectedCharges,
        partialAddAmount,
        setPartialPaymentAmount,
        setSelectedChargesAmount,
        selectedChargesAmount,
        setSelectedCharges,
        currentPaymentMode,
        setCurrentPaymentMode,
        bankDropdown,
        setBankDropdown,
        setPaymentModeForm,
        paymentModeForm,
        paymentModeFormHandler,
        disableItemSelection,
        setDisableItemSelection,
        roleId,
        setRoleId,
        bankMasterId,
        setBankMasterId,
        balanceAmount,
        setBalanceAmount,
        balanceMode,
        setBalanceMode,
        loader,
        setloader,
        collectPayment,
        setCollectPayment,
        collectVoucherList,
        setCollectVoucherList,
        paymentModeIdLimitList,
        setPaymentModeIdLimitList,
        modifyPaymentModeData,
        setModifyPaymentModeData,
        noAmountChange,
        setNoAmountChange,
        totalUnpaidAmount,
        setTotalUnpaidAmount,
        state,
        setState,
        ...props,

        //validation functions
        validatePaymentMode
      }}
    >
      {children}
    </ReceiptListContext.Provider>
  );
};
